import { CampaignWebhooksService } from '../services';
import type { TransitionRule } from '../services';

export type WebhookPayload = {
  url: string;
  enabled: boolean;
  history_limit: number;
  transition_filter: Array<TransitionRule>;
  /** Platform events this endpoint also receives; null clears the subscription. */
  event_types?: string[] | null;
  secret?: string | null;
};

export const getCampaignWebhooks = (campaignId: string) => {
  return CampaignWebhooksService.listWebhooksApiCampaignsCampaignIdWebhooksGet(
    campaignId
  );
};

export const getWebhookDeliveries = (
  campaignId: string,
  subscriptionId: string
) => {
  return CampaignWebhooksService.listDeliveriesApiCampaignsCampaignIdWebhooksSubscriptionIdDeliveriesGet(
    campaignId,
    subscriptionId
  );
};

export const createCampaignWebhook = (
  campaignId: string,
  payload: WebhookPayload
) => {
  return CampaignWebhooksService.createWebhookApiCampaignsCampaignIdWebhooksPost(
    campaignId,
    payload
  );
};

export const updateCampaignWebhook = (
  campaignId: string,
  subscriptionId: string,
  payload: WebhookPayload
) => {
  return CampaignWebhooksService.updateWebhookApiCampaignsCampaignIdWebhooksSubscriptionIdPatch(
    campaignId,
    subscriptionId,
    payload
  );
};

export const deleteCampaignWebhook = (
  campaignId: string,
  subscriptionId: string
) => {
  return CampaignWebhooksService.deleteWebhookApiCampaignsCampaignIdWebhooksSubscriptionIdDelete(
    campaignId,
    subscriptionId
  );
};

export const testCampaignWebhook = (
  campaignId: string,
  subscriptionId: string
) => {
  return CampaignWebhooksService.testWebhookApiCampaignsCampaignIdWebhooksSubscriptionIdTestPost(
    campaignId,
    subscriptionId
  );
};

export const replayWebhookDelivery = (
  campaignId: string,
  subscriptionId: string,
  deliveryId: string
) => {
  return CampaignWebhooksService.replayDeliveryApiCampaignsCampaignIdWebhooksSubscriptionIdDeliveriesDeliveryIdReplayPost(
    campaignId,
    subscriptionId,
    deliveryId
  );
};

export type { WebhookTestResult } from '../services';
export type { WebhookDeliveryResponse } from '../services';
export type { WebhookSubscriptionResponse } from '../services';
